contact<template>
  <div class="discussion">
    <el-row>
      <Message v-for="(message, index) in messages" :key="index" :message="message"/>
      <el-col :span="24">
        <el-form @submit.native.prevent="sendMessage">
          <el-input
            type="textarea"
            :rows="5"
            v-model="message" />
            <div class="discussion__actions">
              <InputUpload
                :id="'discussion-files'"
                :text="$t('contact.creation.modal.form.fileUpload')"
                :files.sync="files"
                multiple
              />
              <el-button
                native-type="submit"
                type="primary">
                {{ $t('contact.creation.sendMessage') }}
              </el-button>
            </div>
          </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Message from '@/components/contact/Message.vue';
import InputUpload from '@/utils/components/InputUpload.vue';

export default {
  name: 'discussion',
  components: {
    Message,
    InputUpload,
  },
  data() {
    return {
      files: [],
      message: '',
      messages: [
        {
          author: 'TUTU',
          isContact: false,
          imgs: [
            'https://m.media-amazon.com/images/I/71jFBNSNmEL._SS500_.jpg',
            'https://i.ytimg.com/vi/Nw6HITbNf3E/hqdefault.jpg',
          ],
          message: 'dadawdawdaw dadawdawdaw dadawdawdaw dadawdawdaw dadawdawdaw dadawdawdaw dadawdawdaw',
          createdAt: new Date(),
        },
        {
          author: 'TITI',
          isContact: true,
          imgs: [
            'https://m.media-amazon.com/images/I/71jFBNSNmEL._SS500_.jpg',
            'https://i.ytimg.com/vi/Nw6HITbNf3E/hqdefault.jpg',
          ],
          message: 'dadawdawdaw dadawdawdaw dadawdawdaw dadawdawdaw dadawdawdaw dadawdawdaw',
          createdAt: new Date(),
        },
        {
          author: 'TUTU',
          isContact: false,
          imgs: [],
          message: 'dadawdawdaw dadawdawdaw dadawdawdaw dadawdawdaw dadawdawdaw dadawdawdaw dadawdawdaw dadawdawdaw dadawdawdaw',
          createdAt: new Date(),
        },
        {
          author: 'TUTU',
          isContact: false,
          imgs: [],
          message: 'dadawdawdaw',
          createdAt: new Date(),
        },
        {
          author: 'TITI',
          isContact: true,
          imgs: [],
          message: 'dadawdawdaw dadawdawdaw dadawdawdaw dadawdawdaw dadawdawdaw dadawdawdaw dadawdawdaw',
          createdAt: new Date(),
        },
      ],
    };
  },
  methods: {
    submitMessage() {
      this.$refs.messageForm.validate((valid) => {
        if (valid) {
          this.sendMessage();
        }
      });
    },
    sendMessage() {
      const formData = new FormData();
      formData.append('message', this.message);
      for (let i = 0; i < this.form.files.length; i += 1) {
        formData.append('files', this.files[i]);
      }
      // this.postContact(formData);
    },
  },
};
</script>

<style lang="scss" scoped>
  .discussion {
    position: relative;
    &__actions {
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
    }
  }
</style>
